import { createContext, useContext } from 'react';

const MemberFormContext = createContext({});

export const MemberFormProvider = ({ children, ...props }) => {
  return <MemberFormContext.Provider value={{ ...props }}>{children}</MemberFormContext.Provider>;
};

export const useMemberFormContext = () => useContext(MemberFormContext);
